import { END } from 'redux-saga';
import rootSaga from './rootSaga';

/* eslint-disable no-param-reassign */

export default function decorateStore(store, sagaMiddleware) {
  // Starts watching sagas by entering a while loops
  store.runSaga = () => {
    // Avoid running twice
    if (store.task) return;
    store.task = sagaMiddleware.run(rootSaga);
  };

  // Breaks from the while loops and terminates all sagas
  // After this call it is safe to start run sagas again
  store.breakAndWaitSagas = async () => {
    // Avoid running twice
    if (!store.task) return;
    store.dispatch(END);
    await store.task.done;
    // Avoid circular json error with node.js >=8.0
    store.task = null;
  };

  // Executes many sagas as isolated block
  // waits for each to finish and then breaks the loop
  store.execSagaTasks = async (isServer, tasks) => {
    // Run saga
    store.runSaga();
    // Dispatch saga tasks
    tasks(store.dispatch);
    // Stop running and wait for the tasks to be done
    await store.breakAndWaitSagas();
    // Re-run on client side
    if (!isServer) {
      store.runSaga();
    }
  };
}



// WEBPACK FOOTER //
// ./app/sagas/decorateStore.js